export const QUERY_KEYS = {
  SESSION: ["session"],
} as const;
